export const useLocationData = () => {

  const config = useRuntimeConfig()

  const transform = (response) => {
    const data = (response?.data || []).map((element) => {
      const attributes = element?.attributes || {};
      return {
        id: element?.id ?? null,        
        name: attributes.name,
        slug: attributes.slug,
        description: attributes.description,
        listingImage: attributes.listingImage === null ? null : attributes?.listingImage?.data?.attributes,
        pulseLocation: attributes?.pulseLocation?.data?.attributes ?? { status: { typeId: null, name: null } },
        distance: attributes.distance,
        url:  attributes.url,
        pulseId: attributes.pulseId,
        marketingText: attributes.marketingText,
      }
    })      
    return {
      data: data,        
      meta: response.meta
    }
  }

  const transformDrawer = (response) => {
    
    return {
      locationsWithinRadius: response.updatedlocationsWithinRadius,        
      otherLocations: response.updatedOtherLocations
    }
  }

  const transformLocation = (response) => {
    const { sanitize } = useUtils();
    const data = response?.data || {};
    const attributes = data?.attributes || {};
    const entity = attributes?.entity || {};
    return {
      locations: attributes.locations,
      nearest: attributes.nearest,
      entity: {
        ...entity,
        listingImage: entity.listingImage === null ? null : entity.listingImage,
        heroGallery: entity.heroGallery === null ? null : entity.heroGallery,
        overview: sanitize((entity.overview || []).map((element) => {
          const result = {
            ...element,
            component: element.__component,
          }
          delete result.__component;
          return result;
        })),
        campusLife: sanitize((entity.campusLife || []).map((element) => {
          const result = {
            ...element,
            component: element.__component,
          }
          delete result.__component;
          return result;
        })),
        instructors: sanitize((entity.instructors || []).map((element) => {
          const result = {
            ...element,
            component: element.__component,
          }
          delete result.__component;
          return result;
        })),
        faqs: sanitize((entity.faqs || []).map((element) => {
          const result = {
            ...element,
            component: element.__component,
          }
          delete result.__component;
          return result;
        })),
        pulseLocation: entity.pulseLocation ? {
          ...entity.pulseLocation,
          status: {
            name: entity?.pulseLocation?.status?.name,
            typeId: parseInt(entity?.pulseLocation?.status?.typeId) || null
          }
        } : { status: { typeId: null, name: null }, address: { state: '', country: '' } }
      },
      seo: sanitize(attributes.seo),
      publishedAt: sanitize(attributes.publishedAt)
    }
  }

  const transformShared = (response) => {
    const { sanitize } = useUtils();
    const attributes = response?.data?.attributes || {};
    const rawGallery = sanitize(
      Array.isArray(attributes?.sharedHeroGallery?.data)
        ? attributes.sharedHeroGallery.data
        : []
    );
    const heroGallery = rawGallery.map((element) => {
      return {
        id: element?.id ?? null,
        ...(element?.attributes ?? {})
      }
    })
    
    const result = {
      ...attributes,
      sharedHeroGallery: heroGallery
    }

    return result;
  }

  const transformLeadGen = (response) => {
    const attributes = response?.data?.attributes || {};
    const result = {
      ...attributes
    }
    return result;
  }
  const transformShortForm = (response) => {
    const attributes = response?.data?.attributes || {};
    const result = {
      ...attributes
    }

    return result;
  }

  

  const transformSettings = (response) => {
    const {sanitize} = useUtils();
    const data = response?.data || {};
    const attributes = data?.attributes || {};
    const result = {
      id: data?.id ?? null,
      flexibleProgramsTitle: attributes.flexibleProgramsTitle,
      navigationMenu: attributes.navigationMenu,
      heroHeader: sanitize(attributes.heroHeader),
      jumpToTop: attributes.jumpToTop,
      displayHero: attributes.displayHero,
      brochureRibbon: attributes.brochureRibbon,
      brochureRibbonTags: attributes.tagsArray,
      seo: sanitize(attributes.seo),
      showChatService: attributes.showChatService
    } 

    return result;
  }



  const locationsByState = async (filters) => {
    const { data: result, error } = await find(200);
    const catalog = {};
  
    if (!error.value) {
      result.value.data.forEach((element) => {
        const state = element.pulseLocation.address.state;
        const subRegion = element.pulseLocation.address.subRegion;
        const country = element.pulseLocation.address.country;
  
        if (country === 'United States') {
          if (
            state &&
            element.pulseLocation.locationTypeID !== 14002 &&
            ((filters.length === 1 && filters[0] === 'all') ||
              filters.some(
                (d) =>
                  element.pulseLocation.divisions &&
                  element.pulseLocation.divisions.indexOf(Number(d)) >= 0
              ))
          ) {
            element.url = `${slugify(state)}-summer-camps/${element.slug}`;
  
            const key = subRegion ? `${state} - ${subRegion}` : state;
  
            if (!catalog[key]) {
              catalog[key] = [element];
            } else {
              catalog[key].push(element);
            }
          }
        }
      });
    }
  
    return Object.keys(catalog)
      .filter((key) => {
        const stateData = catalog[key];
        // Check if there is at least one entry with a status that is not 'inactive'
        return stateData.some(
          (entry) => entry.pulseLocation.status.typeId !== "-1"
        );
      })
      .sort()
      .reduce((obj, key) => {
        const stateData = catalog[key].filter(
          (entry) => entry.pulseLocation.status.typeId !== "-1"
        );
        // Only include the state if it has active locations
        if (stateData.length > 0) {
          // Sort locations alphabetically
          stateData.sort((a, b) =>
            a.pulseLocation.name.localeCompare(b.pulseLocation.name)
          );
  
          obj[key] = stateData;
        }
        return obj;
      }, {});
  };
  
  
  const slugify = (string) => {
    return string.toLowerCase()
                .trim()
                .replace(/[^\w\s-]/g, '')
                .replace(/[\s_-]+/g, '-')
                .replace(/^-+|-+$/g, '');
  }

  const find = async (pageSize = 25, _deep = true) => {
    const url = `/api/locations?pageSize=${pageSize}`
    
    return await useFetch(url, {
      method: 'GET',
      transform: transform
    }); 
  }

  const search = async (searchTerm, page, distance = 250) => {
    
    const url = `/api/location-search?searchTerm=${searchTerm.value}&page=${page}&distance=${distance}`
    
    return await useFetch(url, {
      method: 'GET',
      transform: transform
    });
  }

  // TODO Improve this service to cache the locations and also only return Location Ids
  const searchLocationFilter = async (searchTerm, distance = 90) => {
    
    const url = `/api/location-search?searchTerm=${searchTerm}&page=1&pageSize=100&distance=${distance}`
    
    return await useFetch(url, {
      method: 'GET',
      transform: transform
    });
  }

  const locationSearchDrawer = async (searchTerm, distance = 90) => {
    const url = `/api/location-search-all?searchTerm=${searchTerm}&distance=${distance}`
    
    return await useFetch(url, {
      method: 'GET',
      transform: transformDrawer
    });
  }

  const locationCatalogSettings = async (_deep = true) => {    
    const url = `/api/location-catalog-settings`
    
    return await useFetch(url, {
      method: 'GET',
      transform: transformSettings
    });
  }

  const locationSharedContent = async (_deep = true) => {    
    const url = `/api/location-shared-content`
    
    return await useFetch(url, {
      method: 'GET',
      transform: transformShared
    });
  }
  const locationShortForm = async (_deep = true) => {    
    const url = `/api/location-short-form`
    
    return await useFetch(url, {
      method: 'GET',
      transform: transformShortForm
    });
  }

  const locationLeadGen = async (_deep = true) => {
    const url = `/api/lead-location-form`

    let res = await useFetch(url, {
      method: 'GET',
      transform: transformLeadGen
    })
    return res.data
  }

  const getLocationBySlug = async (slug) => {
    const url = `/api/location-by-slug?slug=${slug}`;

    return await useFetch(url, {
      method: 'GET',
      transform: transformLocation
    });
  }

  const locationDockedNavigation = async (_deep = true) => {    
    const url = `/api/location-docked-navigation`
    
    return await useFetch(url, {
      method: 'GET',
      transform: ((response) => {
        const result = {
          ...response.data.attributes
        }    
        return result;
      })
    });
  }

  const getLocationsByDivision = async (division) => {
    const url = `/api/locations-by-division/?division=${division}`;
    return await useFetch(url, {
      method: 'GET',
    });
  }

  const getLocationsByCords = async (params) => {
    // Convert divisionIds array to a comma-separated string
    if (Array.isArray(params.division)) {
      params.division = params.division.join(',');
    }    
    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&');
    const url = `/api/locations-by-coordinates/?${queryString}`;    
    if (config.public.nuxtEnvironment === 'production') {
      return await useFetch(url, {
        method: 'GET',
      });
    }

    return await useFetch(url, {
      method: 'GET',
      initialCache: true
    });
  }

  const locationFetch = (type) => {
    switch (type) {
      case 'leadGenData':
        return $fetch('/api/lead-gen')
      case 'locationSharedContent':
        return $fetch('/api/location-shared-content')
      case 'locationLeadGen':
        return $fetch('/api/lead-location-form')
      case 'locationShortForm':
        return $fetch('/api/location-short-form')
      case 'locationDockedNavigation':
        return $fetch('/api/location-docked-navigation')
    }
  }  

  const transformFetch = (type, response) => {
    switch(type) {
      case 'leadGenData': {
        const { sanitize } = useUtils()

        return {
          leadGenFields: sanitize(response.data.attributes.leadGenFields)
        }
      }
      case 'locationSharedContent':
        return transformShared(response)
      case 'locationLeadGen':        
        return transformLeadGen(response)
      case 'locationShortForm':
        return transformShortForm(response)
      case 'find':
        return transform(response)
      case 'search':
        return transform(response)
      case 'locationDockedNavigation': {
        const result = {
          ...response.data.attributes
        }
        return result
      }
    }
  }

  const trustPilotReviews = async () => {
    const url = `/api/trustpilot-reviews`
    return await useFetch(url, {
      method: 'GET',
    })
  }

  const transformTrustPilot = (reviews, tagName) => { 
    let result = {
      averageRating: 0,
      totalReviews: 0
    };

    if (reviews.value.data) {
      
      reviews.value.data.forEach((review) => {             
        if (review.attributes.tagName === tagName) { 
          result = review.attributes;
        }
      });
    }; 

    return result; 
  }

  return {
    find,
    search,
    locationsByState,
    slugify,
    locationCatalogSettings, 
    searchLocationFilter,
    getLocationBySlug,
    locationSharedContent,
    locationLeadGen,
    locationShortForm,
    locationDockedNavigation,
    getLocationsByDivision,
    locationFetch,
    transformFetch,
    locationSearchDrawer,
    getLocationsByCords,
    trustPilotReviews,
    transformTrustPilot
  }
}